export default __webpack_public_path__ + "static/media/cover3.69c7d5f9.jpeg";